export const MODULES = [
  'Zoekfunctie',
  'Nieuwsbrief',
  'FAQ',
  'Retourneren',
  'Eerste login',
  'Activatiepagina',
  'Gamification',
  'Productreviews',
  'Mijn account',
  'Bestelgeschiedenis',
  'AV accepteren deactiveren',
  'Aanpassen afleveradres deactiveren',
  'Emailadres in factuur- en afleveradres deactiveren',
  'Opmerkingenveld',
  'AV deactiveren',
  'PP deactiveren',
  'Reserveringen deactiveren',
  'Gebruiker zoeken op klantnummer',
  'Kortingscode',
  'Prijsfilter deactiveren',
  'Accordatie orders',
  'Welkomsttekst',
  'Tag filter',
  'Prijs filter',
  'Categorie filter',
  'Klachtenformulier',
  'Ideeenformulier',
  'Eigen bijdrage'
]

export const EMAILS = [
  { id: 'invite_email', name: 'Uitnodigingsemail' },
  { id: 'order_created_confirmation', name: 'Order geplaatst (confirmatie naar klant)' },
  { id: 'order_shipment_completed_confirmation', name: 'Order verzonden (confirmatie naar klant)' },
  { id: 'order_payment_reminder', name: 'Betalingsherinnering bij deelbetaling (confirmatie naar klant)' },
  { id: 'order_created_report', name: 'Order geplaatst (rapportage naar beheerder)' },
  { id: 'order_shipment_completed_report', name: 'Order volledig verzonden (rapportage naar beheerder)' },
  { id: 'order_payment_reminder_report', name: 'Betalingsherinnering bij deelbetaling (rapportage naar beheerder)' },
  { id: 'user_activation_reminder', name: 'herinnering niet-geactiveerde gebruikers (na 1, 2 & 3 weken)' },
  { id: 'disable_password_reset_email', name: 'E-mail bij wachtwoordherinnering UITZETTEN' },
]

export const CLIENT_ID = 'WR4E9HXQZW'
export const ENDPOINT = 'https://sso0.iloyalty.io'
export const SECRET = 'BFEDD90D982F2D5C34C7CD7852DFB49EB5FCBFE28AF423438BB7CE224D61126D'

export default {
  MODULES,
  EMAILS,
  CLIENT_ID,
  ENDPOINT,
  SECRET
}



// WEBPACK FOOTER //
// ./settings.js